import { Pipe, PipeTransform } from '@angular/core';
import { Trade } from '../models/service-provider-info-model';

@Pipe({
    name: 'getTradeName',
    standalone: true
})
export class GetTradeNamePipe implements PipeTransform {
    transform(tradeIds: string[], tradeList: Trade[], maxItemCount: number = -1): string {
        if (tradeIds?.length === 0 || tradeList?.length === 0) {
            return 'N/A';
        }

        const tradeIdSet = new Set(tradeIds); // otherwise we need to iterate every time
        const tradeNames = tradeList.filter(trade => tradeIdSet.has(trade.id)).map(trade => trade.name);

        if (maxItemCount > -1 && tradeNames.length > maxItemCount) {
            return tradeNames.slice(0, maxItemCount).join(', ') + '...';
        }

        return tradeNames.length > 0 ? tradeNames.join(', ') : 'N/A';
    }
}
